<template>
  <card class="card" title="Reprint Order">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-12">
            <fg-input type="text" label="Barcode ID" v-model="reprint.barcode">
            </fg-input>
          </div>
        </div>

        <div class="row"></div>

        <div class="row"></div>

        <div class="row"></div>
        <!-- 
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Notes</label>
              <textarea
                rows="5"
                class="form-control border-input"
                v-model="reprint.notes"
              >
              </textarea>
            </div>
          </div>
        </div> -->
        <div class="text-center">
          <p-button
            type="info"
            round
            @click.native.prevent="getOrderByBarcodeID"
          >
            GET Order
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import * as reprintOrderService from "../../services/reprintOrder.service";
import { EventBus } from "@/event-bus";

export default {
  data() {
    return {
      reprint: {
        barcode: "",
        notes: "",
      },
    };
  },
  methods: {
    getOrderByBarcodeID: function () {
      let barcodeID = this.reprint.barcode;
      reprintOrderService
        .getOrderDetails(barcodeID)
        .then((response) => {
          console.log("response::: " + JSON.stringify(response));
          response.items.error ? "swal" : this.emitGetOrderEvent(response);
        })
        .catch((err) => {
          console.log("error barcode; " + JSON.stringify(err.message));
        });
    },
    emitGetOrderEvent: function (order) {
      EventBus.$emit("eventing", order);
    },
  },
};
</script>
<style>
</style>
